module.exports = __webpack_public_path__ + "static/media/african-independent.e6558bea.svg";